import mailboxAxios from "../utils/mailboxAxios";

export const notificationAdminApi = {
  getSummary: () => mailboxAxios.get("/notifications/analytics/summary"),
  runEscalations: () => mailboxAxios.post("/notifications/run-escalations"),
};